document.addEventListener('DOMContentLoaded', function() {
  var btn = document.getElementById('load-more-faqs');
  var hiddenItems = document.querySelectorAll('.faq-item.hidden-faq');
  if (!btn) return; 
  if (window.innerWidth > 989 || hiddenItems.length === 0) {
    btn.style.display = 'none';
  }
  btn.addEventListener('click', function() {
    hiddenItems.forEach(function(item) {
      item.classList.remove('hidden-faq');
    });
    btn.style.display = 'none';
  });

});

// Smooth scroll function with header offset
function smoothScroll(target) {
  var header = document.querySelector('sticky-header'); // Make sure this is the correct selector
  var headerHeight = (header ? header.offsetHeight + 10 : 150);
  var targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
  window.scrollTo({
    top: targetPosition,
    behavior: 'smooth'
  });
}

// const parent = document.querySelector(".article-main-wrapper");
// const listItems = parent.querySelectorAll('.collepsible_sublist li');
// const h3Elements = parent.querySelectorAll('h3');
// listItems.forEach((li, index) => {
//   li.addEventListener('click', function (e) {
//     console.log("li",h3Elements,h3Elements[index],index);
//     e.preventDefault(); 
//     if (h3Elements[index]) {
//       console.log("h3Elements",h3Elements);
//       smoothScroll(h3Elements[index]);
//     }
//   });
// });

// const parent = document.querySelector(".article-main-wrapper");
// const listItems = parent.querySelectorAll('.collepsible_sublist li');
// const h3Elements = parent.querySelectorAll('h3');

// // Set index offset if your <li> list is longer than the <h3> list
// const offset = listItems.length - h3Elements.length;

// listItems.forEach((li, index) => {
//   const h3Index = index - offset;

//   li.addEventListener('click', function (e) {
//     e.preventDefault();
//     const h3 = h3Elements[h3Index];
//     if (h3) {
//       const scrollTarget = h3.closest('.section-wrapper'); // Replace with your actual wrapper class
//       if (scrollTarget) {
//         smoothScroll(scrollTarget);
//       } else {
//         smoothScroll(h3); // fallback to h3
//       }
//     } else {
//       console.warn("No matching h3 found for index:", h3Index);
//     }
//   });
// });

const links = document.querySelectorAll('.collepsible_sublist li a');
links.forEach((link) => {
  link?.addEventListener('click', function (e) {
    e.preventDefault();
    const href = this.getAttribute('href');
    if (!href || !href.startsWith('#')) return;
    const targetId = href.slice(1); // Remove the "#" to get the ID
    const scrollTarget = document.getElementById(targetId);
    if (scrollTarget) {
      smoothScroll(scrollTarget);
    } else {
      console.warn("No element found with ID:", targetId);
    }
  });
});


let priceText = document.querySelector(".pricing-product")?.textContent.trim() || "0";
if(priceText){
              let cleanPrice = parseFloat(priceText.replace(',', '.').replace(/[^0-9.]/g, ''));
               const price_data = document.querySelector("[data-price-store]");             
              const price_set = price_data?.setAttribute("data-price-store",cleanPrice);
}
  